import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-[12px] border border-brand-border bg-white px-4 py-3 text-base",
        "text-brand-text placeholder:text-brand-muted",
        "shadow-none transition-[border-color,box-shadow] duration-200 ease-out",
        "focus-visible:outline-none focus-visible:border-brand-accent focus-visible:ring-2 focus-visible:ring-brand-accent/25",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-brand-surface",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-brand-text",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
